import fogueteEtapa1 from 'assets/img/2026/foguete_etapa1.png';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { isAssessorEtapa3, getVpDestino } from 'types/etapa3';
import { HeaderElbb } from '../HomeElbb/components';

export function ConfirmacaoVotoEtapa3() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAssessor = isAssessorEtapa3(user ?? null);
  const vpDestino = getVpDestino(user ?? null);

  return (
    <div className="min-h-screen bg-gray-100">
      <HeaderElbb currentPage="inicio" />

      <main className="px-4 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <section className="max-w-[520px]">
            <h1 className="m-0 text-blue-bb-1 text-4xl md:text-5xl font-bold leading-tight">
              {isAssessor
                ? 'Voto preliminar enviado!'
                : 'Seus votos foram enviados!'}
            </h1>

            <p className="mt-6 mb-0 text-base md:text-lg text-gray-600 leading-relaxed">
              {isAssessor ? (
                <>
                  O voto preliminar foi enviado
                  {vpDestino?.nome ? <> para <strong>{vpDestino.nome}</strong></> : null}
                  . Agora é só aguardar a revisão e a confirmação do voto final.
                </>
              ) : (
                'Parabéns por sua contribuição na escolha das iniciativas que representam o Prêmio ELBB.'
              )}
            </p>

            {!isAssessor && (
              <p
                className="mt-3 mb-0 text-base md:text-lg font-semibold leading-relaxed"
                style={{ color: '#FF7AB6' }}
              >
                Fique ligado, o resultado final sai dia 01/06!
              </p>
            )}

            <button
              type="button"
              className="mt-8 bg-yellow-bb text-blue-bb border-0 rounded-lg px-8 py-3 text-sm font-extrabold cursor-pointer"
              onClick={() => navigate(isAssessor ? '/votacao-etapa-3' : '/meus-votos-etapa-3')}
            >
              {isAssessor ? 'VER MEU VOTO PRELIMINAR' : 'MOSTRAR MEUS VOTOS'}
            </button>
          </section>

          <section className="flex justify-center lg:justify-end">
            <img
              src={fogueteEtapa1}
              alt="Ilustração de foguete"
              className="w-full max-w-[460px] h-auto"
            />
          </section>
        </div>
      </main>
    </div>
  );
}
